import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable({
providedIn:'root'
})
export class ApiHttpService{
    constructor(private http:HttpClient) {}
    private appendFrontendHeader(){
        let headers = new HttpHeaders();
        return headers.append('service','ui-service');
    }
    public get(url:string,options?:any){
        options = options || {headers:this.appendFrontendHeader()};
        return this.http.get(url,options);
    }
}